document.addEventListener('DOMContentLoaded', function() {
    const dropdownContainer = document.getElementById('dropdownContainer');
    const dropdownToggle = document.getElementById('dropdownToggle');
    const dropdownMenu = dropdownContainer.querySelector('.dropdown-menu');
    const dropdownItems = document.querySelectorAll('.nav__section--list .dropdown-item');
    let activeItemFound = false;
  
  
    // Move all dropdown-items to the dropdown container
    dropdownItems.forEach(item => {
        // Clone and append to dropdown menu
        let clonedItem = item.cloneNode(true);
        dropdownMenu.appendChild(clonedItem);
  
        // Check if the item has 'active' class
        if (item.classList.contains('active')) {
            activeItemFound = true;
            // Replace dropdown toggle content with active item's content
            dropdownToggle.innerHTML = clonedItem.innerHTML;
            // Add 'active' class to dropdownContainer
            dropdownContainer.classList.add('active');
            // Remove the cloned active item from the dropdown menu
            clonedItem.remove();
        }
  
        // Remove from original location
        item.remove();
    });
  
    // Default text if no active item found
    if (!activeItemFound) {
      if (document.documentElement.lang === 'en-US') {
          dropdownToggle.textContent = 'BUSINESS CUSTOMERS';
      } else if (document.documentElement.lang === 'de-DE') {
          dropdownToggle.textContent = 'GESCHÄFTSKUNDEN';
      } else if (document.documentElement.lang === 'fr-CH') {
          dropdownToggle.textContent = 'CLIENTS PROFESSIONNELS';
      }
  }
  
    // Update active item on click
    dropdownMenu.addEventListener('click', function(event) {
        let clickedItem = event.target.closest('.dropdown-item');
        if (clickedItem) {
            // Update the dropdown toggle text
            dropdownToggle.innerHTML = clickedItem.innerHTML;
            // Add 'active' class to dropdownContainer
            dropdownContainer.classList.add('active');
            // Optionally, perform additional actions like storing the state
        }
    });
  
    // Reset when other items are clicked
    // Adjust the selector as per your HTML structure
    document.querySelectorAll('.nav__section--list > li:not(.dropdown), a.header__logo').forEach(function(item) {
        item.addEventListener('click', function() {
          dropdownToggle.textContent = 
          document.documentElement.lang === 'en-US' ? 'BUSINESS CUSTOMERS' :
          document.documentElement.lang === 'fr-CH' ? 'CLIENTS PROFESSIONNELS' :
          'GESCHÄFTSKUNDEN';
            // Remove 'active' class from dropdownContainer
            dropdownContainer.classList.remove('active');
            // Optionally reset additional state here
        });
    });
  });
  